import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import config from '../../../config';

export const Top_p_Modal = () => {

    const [modal_standard, setmodal_standard] = useState(false);
    function tog_standard() {
        setmodal_standard(!modal_standard);
    }

  return (
    <>
         <span color="secondary" onClick={() => tog_standard()} style={{ backgroundColor: 'transparent', border: 'none', padding: '0px', fontSize: '18px', cursor: 'pointer'}}><i className="ri-question-line"></i></span>
      
       {/* Default Modal */}
       <Modal id="myModal"
                isOpen={modal_standard}
                toggle={() => {
                    tog_standard();
                }}
            >
                <ModalHeader className="modal-title"
                    id="myModalLabel" toggle={() => {
                        tog_standard();
                    }}>
                        Top P
                </ModalHeader>
                <ModalBody>
                    {/* <h5 className="fs-15">
                    number or null
                    </h5> */}
                    <p className="text-muted">{config.tool_tip.top_p}</p>
                    {/* <p className="text-muted">Defaults to 1</p>
                    <p className="text-muted">An alternative to sampling with temperature, called nucleus sampling, where the model considers the results of the tokens with top_p probability mass. So 0.1 means only the tokens comprising the top 10% probability mass are considered.</p> */}
                    {/* <p className="text-muted"></p> */}
                </ModalBody>
                
            </Modal>
    </>
  )
}
